export default __webpack_public_path__ + "static/media/No46.235558f5.jpg";